var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('video',{ref:"docVideo",staticClass:"CameraVideo",attrs:{"autoplay":"","vc-splitscreen-is-aspect-ratio-source":"true","playsinline":"true"}}),_c('canvas',{ref:"docCanvas",staticStyle:{"visibility":"hidden","position":"absolute"},attrs:{"id":"canvasDocPhoto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }